import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Lucky Flamingo (native Incisor port, real wallet via /api/lucky-flamingo/v2).
export default function LfRoute() {
    const navigate = useNavigate();
    const { refreshUser } = useAuth();
    const frame = useRef(null);
    useEffect(() => {
        function receive(e) {
            if (e.origin !== window.location.origin || e.source !== frame.current?.contentWindow) return;
            if (e.data?.type === 'lf:exit') { refreshUser?.(); navigate('/casino/slots'); }
        }
        window.addEventListener('message', receive);
        return () => window.removeEventListener('message', receive);
    }, [navigate, refreshUser]);
    return (
        <iframe ref={frame} data-testid="lf-game-frame" src="/games/lf/index.html?v=5" title="Lucky Flamingo" allow="autoplay; fullscreen" allowFullScreen
            style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 0, background: '#03060f', zIndex: 60 }} />
    );
}
